import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { StatusFragmentDoc } from '../../fragments/generated/Status';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type StatusesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.StatusesFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type StatusesQuery = { statuses: { edges?: Array<{ node: { id: string, name: string, progress?: number | null, category: Types.StatusCategoryEnum, order?: number | null, icon?: { type: Types.IconTypeEnum, value: string } | null } }> | null } };


export const StatusesDocument = /*#__PURE__*/ gql`
    query statuses($filters: StatusesFilters, $sort: [SortType!]) {
  statuses(filters: $filters, sort: $sort, first: -1) {
    edges {
      node {
        ...Status
      }
    }
  }
}
    ${StatusFragmentDoc}`;

export function useStatusesQuery(options?: Omit<Urql.UseQueryArgs<StatusesQueryVariables>, 'query'>) {
  return Urql.useQuery<StatusesQuery, StatusesQueryVariables>({ query: StatusesDocument, ...options });
};